// extracted by mini-css-extract-plugin
export var drawerPaper = "_1l-0";
export var itemImage = "_1l-1";